// @flow
/* global window,document */
import { getUserId } from './tracking';
import type { UserType } from '../types/user';

let localAppboy: any;
const isBrowser = () => typeof window !== 'undefined';

export function callBrazeFn(functionName: string, ...args: Array<any>) {
  const instance = isBrowser() ? window.appboy : localAppboy;

  if (instance && typeof instance[functionName] === 'function') {
    instance[functionName](...args);
  }
}

export class Braze {
  static changeUser(user: UserType) {
    const id = getUserId(user);

    callBrazeFn('changeUser', id);
  }
}
